import React from 'react';
import './Contact.css';

import github from "./img/github.png"
import email from "./img/email.png"
import twitter from "./img/twitter.png"
import linkedin from "./img/linkedin.png"
import phone from "./img/phone.png"

function Contact() {
    return (
        <div className="contact component__space" id="Contact">
            <div className="row">
                <div className="col__2">
                    <div className="contact__box">
                        <div className="contact__meta">
                            <h1 className="hire__text">Contact</h1>
                            <p className="hire__text white">I am available for  work.</p>
                           {/* <p className="hire__text white"><strong>6205769341</strong> or email <strong>heyimpankaj2616@gmail.com</strong></p> */}
                        </div>
                        <div className="input__box">
                           <input type="text" className="contact name" placeholder="Your name *" />
                           <input type="text" className="contact email" placeholder="Your Email *" />
                           <input type="text" className="contact subject" placeholder="Write a Subject" />
                           <textarea name="message" id="message" placeholder="Write Your message"></textarea>
                           <button className="btn contact pointer" type="submit">Submit</button>
                        </div>
                    </div>
                </div>
                <div className="col__2" >

                    <div className='icons'>
                        <h1>Contact with me via:</h1>
                        <a href='https://github.com/Dreamboy-26' target="_blank"><img src={github}  alt="" className="contact__img" /></a>
                   <a href='https://www.linkedin.com/in/pankaj-kumar-b7924b194/'  target="_blank"><img src={linkedin}  alt="" className="contact__img" /></a>
                   <a href='https://mail.google.com/mail/u/0/#inbox?compose=GTvVlcRzCMnMQRcSWljCrVGGjDcHGBDvjpVJCFndQLPXGGRqwnDMpHJQSxJMHjvhClbWSqgkZvSnL'  target="_blank"><img src={email}  alt="" className="contact__img" /></a>
                   <a href='https://twitter.com/Impankaj_kr'  target="_blank"><img src={twitter}  alt="" className="contact__img" /></a>
                    {/* <img src={phone}  alt="" className="contact__img" /> */}
                    </div>
                   
                </div>
            </div>
        </div>
    )
}

export default Contact
